import { render, staticRenderFns } from "./ControlBlinds.vue?vue&type=template&id=5bc7e961&scoped=true&"
import script from "./ControlBlinds.vue?vue&type=script&lang=ts&"
export * from "./ControlBlinds.vue?vue&type=script&lang=ts&"
import style0 from "./ControlBlinds.vue?vue&type=style&index=0&id=5bc7e961&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc7e961",
  null
  
)

export default component.exports